// extracted by css-extract-rspack-plugin
export default {"skuInfoContainer":"_fa8cdbe9","attribute":"_611b49b1","attributeLabel":"_dfcf38d7","swatchesContainer":"_eba00946"};